import React from 'react';
import ReportPreviewPage from '../../features/products/previewPage/ReportPreviewPage';
import {buildSnippetScrollTerms} from '../../features/products/previewPage/useReportExcerptScroll';

/**
 * Read-only report viewer used inside the Source Package overlay center pane.
 *
 * Report search hits open here (same overlay window as Corpus / My Files) rather than in a
 * separate browser tab. It now delegates to the shared {@link ReportPreviewPage} in embedded
 * mode (`hideVersionSidebar`) so search-opened reports render identically to the standard
 * readonly preview — numbered citations + references list, classification headers, agentic
 * section markdown, and mention/hashtag/Wikidata popovers — loading the latest persisted
 * version via the same versioned snapshot API.
 *
 * The matched snippet is converted into excerpt-search terms so the preview scrolls to the
 * relevant passage on open (replacing the old, brittle PM chunk-index highlighting).
 */
const OverlayReportView = ({reportId, snippet = null, query = null, active = true}) => {
    const searchTerms = React.useMemo(
        () => buildSnippetScrollTerms(snippet, query),
        [snippet, query],
    );

    if (!active || !reportId) {
        return null;
    }

    return (
        <ReportPreviewPage
            reportId={reportId}
            hideVersionSidebar
            searchTerms={searchTerms}
        />
    );
};

export default React.memo(OverlayReportView);
